import { ChecklistToggleRow } from '@models/checklist-toggle/checklist-toggle.model';

import { QuarterCloseChecklistSection } from '../models/quarter-close-checklist.model';

export function disabledLockTooltip(
  rowId: ChecklistToggleRow | QuarterCloseChecklistSection,
  disabledLock: boolean
): string {
  // If previous quarter, return "disabled previous quarter" tooltip

  // If CloseExpenses is disabled
  if (rowId === ChecklistToggleRow.CloseExpenses && disabledLock) {
    return 'Prior Closing Checklist entries must all be confirmed before Vendor Expenses can be confirmed.';
  }

  // If ConfirmDiscounts is disabled
  if (rowId === ChecklistToggleRow.CloseDiscounts && disabledLock) {
    return 'Prior Closing Checklist entries must all be confirmed before Discount can be confirmed.';
  }

  // If ConfirmClose section is disabled
  if (rowId === QuarterCloseChecklistSection.ConfirmClose && disabledLock) {
    return 'Prior Closing Checklist entries must all be confirmed before this section can be confirmed.';
  }

  return '';
}
